import { render, staticRenderFns } from "./AccountConfirmModal.vue?vue&type=template&id=004ca56a"
import script from "./AccountConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountConfirmModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports